import React from 'react';
import { Link } from 'react-router-dom';
import './styles.css'

function ErrorNotFound() {
    return (
        <>
            <div className="container error__container ">
                <div className="column error__column">
                    <div>
                        <h1>404</h1>
                        <h2>Page you are looking for does not exist!</h2>     
                        <h6>Back to <Link className="tfx-1" to="/">Home</Link></h6>                   
                    </div>
                </div>                
            </div>
        </>
    )
}

export default ErrorNotFound
